// The rules of the Capital's exploration leads (config: LeadConfig in config/capital.js; scene: scene/capitalLeads.js).
// Pure functions — no scene, no DOM — so they can be tested on their own.
import { LeadConfig as L } from '../config/capital.js'

export const smooth = (t) => { const x = Math.max(0, Math.min(1, t)); return x * x * (3 - 2 * x) }

// A lead is showing when you have found the landmark it starts from, you have NOT yet found the one it points at, and — for the
// palace courtyard, which is closed to the public — the gate fee has been paid on this trip.
export const isLeadOpen = (lead, isFound, admitted) => isFound(lead.from) && !isFound(lead.to) && (!lead.admitted || !!admitted)

// How visible a destination ring is from `d` metres away: unseen beyond ringSenseM, faintly there inside it, brightest within ringNearM.
export const ringAlpha = (d) => L.maxOpacity * smooth((L.ringSenseM - d) / (L.ringSenseM - L.ringNearM))

// A stepping-stone dot: only shows near you, and melts away as you walk onto it (so a trail reads as "keep going", not clutter).
export const dotAlpha = (d) => L.maxOpacity * 0.8 * smooth((L.dotSenseM - d) / (L.dotSenseM * 0.55)) * smooth((d - 1.2) / 2.2)

// Leads that opened between two looks (so the ledger can say so once). Each is { from, to, admitted }.
export function newlyOpened(chain, wasOpen, isFound, admitted) {
  const out = []
  for (const l of chain) {
    const open = isLeadOpen(l, isFound, admitted)
    const key = `${l.from}>${l.to}`
    if (open && wasOpen.has(key) === false) out.push(l)
    if (open) wasOpen.add(key); else wasOpen.delete(key)
  }
  return out
}
